import React from "react";

import { useSelector } from "react-redux";

import { GroupedCard } from "components/GroupedCard";

import { getAuctionPenById } from "selectors/auctionPens/basic";

import { getStatusByAuctionPenId } from "selectors";
import { AuctionPenStatus } from "constants/auctionPens";
import GroupSummary from "./GroupSummary";
import SaleLotsGroup from "./SaleLotsGroup";
import { AuctionPenCardActionsSection } from "./AuctionPenCardActions";

interface AuctionPenCardProps {
  auctionPenId: string;
  isOpen: boolean;
  onExpand: (penId: string | undefined) => void;
  weighedOnly?: boolean;
  showSelect?: boolean;
}

function AuctionPenCardComponent(props: AuctionPenCardProps) {
  const {
    auctionPenId,
    isOpen,
    onExpand,
    weighedOnly,
    showSelect = false,
  } = props;

  const auctionPen: AuctionPen | null = useSelector<State, AuctionPen | null>(
    getAuctionPenById(auctionPenId),
  );

  const status: AuctionPenStatus = useSelector<State, AuctionPenStatus>(
    getStatusByAuctionPenId(auctionPenId),
  );

  const toggleDisplaySaleLots = () => {
    if (isOpen) {
      // use undefined instead of null, as null is a valid value representing unpenned
      onExpand(undefined);
    } else {
      onExpand(auctionPenId);
    }
  };

  const groupSummary = <GroupSummary auctionPenId={auctionPenId} />;

  const groupedItems = (
    <SaleLotsGroup
      auctionPenId={auctionPenId}
      weighedOnly={weighedOnly}
      showSelect={showSelect}
    />
  );

  const actions: React.JSX.Element = (
    <AuctionPenCardActionsSection auctionPenId={auctionPenId} />
  );

  return (
    <GroupedCard
      actions={null}
      status={status}
      groupSummary={groupSummary}
      topRow={actions}
      groupedItems={groupedItems}
      onClick={toggleDisplaySaleLots}
      isOpen={isOpen}
      startPen={auctionPen?.start_pen}
    />
  );
}

export const AuctionPenCard = React.memo(AuctionPenCardComponent);
